const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  routes: state => state.user.routes,
  // 刷新token用
  refreshPromise: state => state.user.refreshPromise,

  activeTab: state => state.app.activeTab
}
export default getters
